<template>
  <div>
    <ul
      v-if="role && role.length > 0"
      :class="['sm-cast', showAllContent ? 'show' : '']"
    >
      <li
        v-for="(value, i) in role"
        :key="i"
      >
        <a
          :href="'/star?query=' + encodeURIComponent(value.star) + '&spver=' + spver"
          :uigs="'cast_image_'"
          +value.star
        >
          <img :src="$parent.getResizePicUrl(value.image, 80, 'auto', 200839)">
          <h3>{{ value.star }}</h3>
          <p v-if="value.cate && value.role">{{ cate(value.cate) }}（饰 {{ value.role }}）</p>
          <p v-else-if="value.cate && !value.role">{{ cate(value.cate) }}</p>
          <p v-else-if="!value.cate && value.role">饰 {{ value.role }}</p>
        </a>
      </li>
    </ul>
    <div
      v-show="role.length >= 3"
      :class="['sm-cast-show', showAllContent ? 'hide' : '']"
      @click="showContent"
    >
      <span>展开更多</span>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

import { getSpver, singlePageClParams } from '../../common/js/util';

export default {
  data() {
    return {
      showAllContent: false,
    };
  },
  computed: {
    ...mapState('summary', ['itemData']),
    role() {
      const data = this.itemData;
      if (typeof data === 'undefined' || typeof data.role_info === 'undefined') return [];
      const { role_info: roleInfo } = data;
      if (Object.prototype.hasOwnProperty.call(roleInfo, 'item_list') && roleInfo.item_list.length > 0) {
        const { item_list: itemList } = roleInfo;
        if (itemList && itemList.length > 0) {
          return itemList;
        }
      }
      return [];
    },
    spver() {
      return getSpver({ spver: this.$route.query.spver, returnType: 'num' }) || '';
    },
  },
  methods: {
    showContent() {
      const clParams = singlePageClParams('cast_showContent');
      this.$uigs.send(clParams);
      this.showAllContent = true;
    },
    cate(str) {
      const catemap = {
        starring: '主演',
        director: '导演',
        shengyou: '声优',
        emcee: '主持人',
        guest: '嘉宾',
      };
      const name = catemap[str];
      if (typeof name !== 'undefined') {
        return name;
      }
      return '';
    },
  },
};
</script>

<style lang="scss">
@import '../../../asset/css/abstracts/mixin.scss';
@import '../../../asset/css/abstracts/function_sprite_detail.scss';

.sm-cast {
  padding: 14px 12px 0;
  overflow: hidden;
  max-height: 361px;
}

.sm-cast li {
  height: 111px;
  margin-bottom: 10px;
  padding: 0 0 0 100px;
  position: relative;
}

.sm-cast li:last-child {
  margin-bottom: 0px;
}

.sm-cast li img {
  position: absolute;
  width: 80px;
  height: 111px;
  background: rgba(216, 216, 216, 1);
  border-radius: 5px;
  left: 0;
  top: 0;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: center;
  object-position: center;
}

.sm-cast li h3 {
  font-size: 17px;
  margin-bottom: 12px;
  color: rgba(34, 34, 34, 1);
}

.sm-cast li p {
  font-size: 15px;
  color: #999999;
}
.sm-cast-show {
  margin: 0 14px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  background: rgba(245, 245, 245, 1);
  border-radius: 3px;
  margin-top: 9px;

  span {
    font-size: 13px;
    color: rgba(34, 34, 34, 1);
    &:after {
      content: '';
      display: inline-block;
      @include arr(6px, 135deg, #222);
      margin-left: 6px;
      vertical-align: 3px;
    }
  }
}

.sm-cast.show {
  max-height: unset;
}

.sm-cast-show.hide {
  display: none;
}
</style>
